import * as PN from '@/utils/PermissionNames'

export default {
  namespaced: true,
  state: {},
  getters: {
    user(state, getters, rootState) {
      return rootState.auth.user
    },
    permissions(state, getters) {
      return getters.user && typeof getters.user.permissions !== 'undefined' ? getters.user.permissions : []
    },
    /**
     * Wrapper for permission check. You can override complex permission check into the function in current module getters
     * @param state
     * @param getters
     * @returns {Function}
     */
    can: (state, getters = null) => (permission, params = null) => {
      if (typeof getters[permission] === 'function') {
        return getters[permission](params)
      }
      return getters.permissions[permission] || false
    }
    /*[PN.MAIL_DELETE]: (state, getters) => (authorId) => {
      if (getters.permissions[PN.MAIL_OWN_DELETE]) {
        return getters.user.id === authorId
      }
      return getters.permissions[PN.MAIL_DELETE]
    },
    [PN.MAIL_UPDATE]: (state, getters) => (authorId) => {
      if (getters.permissions[PN.MAIL_OWN_UPDATE]) {
        return getters.user.id === authorId
      }
      return getters.permissions[PN.MAIL_UPDATE]
    },
    [PN.SALE_DELETE]: (state, getters) => (authorId) => {
      if (getters.permissions[PN.SALE_OWN_DELETE]) {
        return getters.user.id === authorId
      }
      return getters.permissions[PN.SALE_DELETE]
    },
    [PN.WORK_ORDER_FILE_UD]: (state, getters) => (authorId) => {
      if (getters.permissions[PN.WORK_ORDER_OWN_FILE_UD]) {
        return getters.user.id === authorId
      }
      return getters.permissions[PN.WORK_ORDER_FILE_UD]
    },

    [PN.SALE_COMMENT_UD]: (state, getters) => (authorId) => {
      return getters.user.id === authorId
    },
    [PN.WORK_ORDER_COMMENT_UD]: (state, getters) => (authorId) => {
      return getters.user.id === authorId
    }*/
  },
  actions: {},
  mutations: {}
}
